export const TICKER_INTERVAL_MS = {
  ONE_HUNDRED: 100,
  ONE_THOUSAND: 1000,
  TEN_THOUSAND: 10000,
}

export default function getTickerFeedChannel(instrument_name: string, interval: number) {
  return `ticker.${instrument_name}.${interval}`
}
